import { graphql, StaticQuery } from "gatsby";
import React from "react";
import "./style.scss";
import {
  getPage,
  TypeComposableWebPage,
  TypeComposableWebQueryResult,
} from "../../utils/queries/composable_web";
import {
  PageHeaderCustomV2WhiteWide,
  PageHeaderStandard,
} from "../../components/page-header/page-header";
import Helmet from "react-helmet";
import { PageTitle } from "../../components/title/title";
import AmazeeIoMetadata from "../../components/metadata";
import RichTextRender from "../../utils/rich-text";
import AmazeePage from "../../components/layout";
import usePreviewData from "../../utils/usePreviewData";
import Calender from "../../components/Calender";

const query = graphql`
  {
    allPrismicComposableWeb {
      edges {
        node {
          data {
            calendar_title
            calendar_embed {
              url
            }
            calender_heading
            calender_subheading
            calender_body {
              html
              raw
              text
            }
            calender_image: image {
              url
              alt
            }
            page_meta_description
            section_subtitle {
              html
              raw
              text
            }

            section_title
            title {
              html
              raw
              text
            }
            meta_title
            hero_image {
              alt
              url
            }

            subtitle {
              html
              raw
              text
            }

            services {
              service_title
              service_description
              service_image {
                alt
                url
              }
            }

            page_meta_thumbnail {
              url
              alt
            }
          }
        }
      }
    }
  }
`;

const ComposableWebPage = ({
  data,
  location,
}: {
  location: Location;
  data: TypeComposableWebQueryResult;
}) => {
  const pageData = getPage(data);
  if (!pageData) return null;
  const result = usePreviewData(
    pageData,
    "PrismicGlobalCdnWaf",
    true
  ) as TypeComposableWebPage;
  const title = result.meta_title ? result.meta_title : result.title.text;

  return (
    <AmazeePage location={location}>
      <div id="composable-web">
        <Helmet>
          <link rel="stylesheet" href="/css/carousel-single.min.css" />
          <link rel="stylesheet" href="/css/carousel-multi.min.css" />
        </Helmet>
        <PageTitle title={title} amazeeOnly={true} />
        <AmazeeIoMetadata
          title={RichTextRender(result?.title?.text)}
          page_meta_description={result.page_meta_description}
          page_meta_thumbnail={result?.page_meta_thumbnail}
          location={location}
        />

        <PageHeaderStandard
          component={PageHeaderCustomV2WhiteWide}
          header={RichTextRender(result?.title)}
          image={result?.hero_image}
          subheader={RichTextRender(result?.subtitle)}
          withSiteName={false}
          hasSectionDivider={false}
        />

        <section id="introduction">
          <div className="container">
            <div className="row flex justify-center items-center">
              <div className="col-12 col-lg-5 text-left">
                <img src={result?.image?.url} alt={result?.image?.alt} />
              </div>
              <div className="col-12 col-lg-5 text-left">
                <div>{RichTextRender(result?.section_text)}</div>
              </div>
            </div>
            <div className="col-12 col-lg-10"></div>
          </div>
        </section>

        <section id="services">
          <div className="container">
            <div className="row flex justify-center">
              <div className="col-8 text-center">
                <h3>{RichTextRender(result?.section_title)}</h3>
              </div>
              <div className="col-12 col-lg-8 text-center">
                <h6>{RichTextRender(result?.section_subtitle)}</h6>
              </div>
            </div>

            <div className="row">
              {result.services.map((service, index) => (
                <div key={index} className="col-12 col-lg-4 service">
                  <img
                    src={service?.service_image?.url}
                    alt={service?.service_image?.alt}
                  />
                  <div className="service-title">{service?.service_title}</div>
                  <div className="description">
                    {service?.service_description}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <Calender
          calender_body={result.calender_body}
          calender_embed={result.calendar_embed}
          calender_heading={result.calender_heading}
          calender_subheading={result.calender_subheading}
          calender_title={result.calendar_title}
          image={result.calender_image}
        />
      </div>
    </AmazeePage>
  );
};

const StaticTypeGlobalCDNWAFPage: React.FC<{ location: Location }> = ({
  location,
}) => {
  return (
    <StaticQuery
      query={query}
      render={(data) => <ComposableWebPage location={location} data={data} />}
    />
  );
};
export default StaticTypeGlobalCDNWAFPage;
